import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, useDrawer } from 'src/mtska-frontend-app-component';

const OperatorAssignation = ({ selected, campaignId, setSelected }) => {
    const { t } = useTranslation();
    const { activate } = useDrawer();

    const handleOperatorAssignation = () => {
        activate('campaignmanagement/operatorAssociation', { selected : [...selected], campaignId : campaignId, setSelected:setSelected });
    };

    return [
        <>
            <Button
                onClick={handleOperatorAssignation}
                label={t("Assegna (" + selected.length + ")")}
                icon="faPeopleArrows"
                family="fas"
                variant="soft"
                size="small"
                className="button-select"
            />
        </>
    ];
};

export default OperatorAssignation;
